import { createReducer } from './functions';

import _ from 'lodash';
import {
	PHOTOTHEQUE_ADD_CURRENT_FILTERS,
	PHOTOTHEQUE_INIT,
	PHOTOTHEQUE_SET_CURRENT_FILTERS,
	PHOTOTHEQUE_SET_MEDIAS,
	PHOTOTHEQUE_SET_PAGINATION,
	PHOTOTHEQUE_FILTERS_LOADING,
	PHOTOTHEQUE_MEDIAS_LOADING,
	PHOTOTHEQUE_SET_FILTERS,
	PHOTOTHEQUE_SET_KEY_FILTER_SELECTED,
	PHOTOTHEQUE_SET_EMAILS_OF_MY_USERS
} from './../types';

const initialState = {
	filters: null,
	currentFilters: {},
	medias: [],
	page: 0,
	pages: 0,
	pageSize: 10,
	hasNext: true,
	filtersLoading: false,
	mediasLoading: false,
	emailsOfMyUsers: null
};

const init = {
	[PHOTOTHEQUE_INIT]: (state, action) => {
		return Object.assign({}, state, { ...initialState });
	}
};

const setEmailsOfMyUsers = {
	[PHOTOTHEQUE_SET_EMAILS_OF_MY_USERS]: (state, action) => {
		return { ...state, emailsOfMyUsers: action.payload };
	}
};
const setFilters = {
	[PHOTOTHEQUE_SET_FILTERS]: (state, action) => {
		return { ...state, filters: { [action.key]: action.values } };
	}
};

const setCurrentFilters = {
	[PHOTOTHEQUE_SET_CURRENT_FILTERS]: (state, action) => {
		return Object.assign({}, state, { currentFilters: action.currentFilters });
	}
};

const setPagination = {
	[PHOTOTHEQUE_SET_PAGINATION]: (state, action) => {
		return Object.assign({}, state, { page: action.page, pages: action.pages });
	}
};

const addCurrentFilter = {
	[PHOTOTHEQUE_ADD_CURRENT_FILTERS]: (state, action) => {
		const currentFilters = state.currentFilters || {};
		currentFilters[action.key] = action.filters;
		return Object.assign({}, state, { currentFilters: currentFilters });
	}
};

const setKeyFilterSelected = {
	[PHOTOTHEQUE_SET_KEY_FILTER_SELECTED]: (state, action) => {
		return { ...state, keyFilterSelected: action.key };
	}
};
const setMedias = {
	[PHOTOTHEQUE_SET_MEDIAS]: (state, action) => {
		const page = action.payload.hasOwnProperty('page') ? action.payload.page : state.page;
		const pages = action.payload.hasOwnProperty('pages') ? action.payload.pages : state.pages;
		let hasNext = true;
		if (page === 0 || page === pages) {
			hasNext = false;
		}
		return { ...state, medias: action.payload.docs, page, pages, hasNext };
	}
};

const mediasLoading = {
	[PHOTOTHEQUE_MEDIAS_LOADING]: (state, action) => {
		return { ...state, mediasLoading: action.loading };
	}
};

const filtersLoading = {
	[PHOTOTHEQUE_FILTERS_LOADING]: (state, action) => {
		return { ...state, filtersLoading: action.loading };
	}
};

const photothequeReducer = createReducer(initialState, {
	...init,
	...setCurrentFilters,
	...addCurrentFilter,
	...setMedias,
	...setPagination,
	...mediasLoading,
	...filtersLoading,
	...setFilters,
	...setKeyFilterSelected,
	...setEmailsOfMyUsers
});

export default photothequeReducer;



// WEBPACK FOOTER //
// src/redux/reducers/photothequeReducer.js